module.exports = __webpack_public_path__ + "static/media/postbox.c1cc1c92.svg";